// La Boiserie — Variant Image Switcher v13
(function() {
  function init() {
    var gallery = document.querySelector('#swiper-gallery-product-template');
    if (!gallery) return;

    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('/')[0];

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {

        // Map variantId -> image index (0-based)
        var variantIndexMap = {};
        // Map option1 value -> variant id
        var valueToVariant = {};
        // Map variantId -> price
        var variantPriceMap = {};
        product.variants.forEach(function(v) {
          if (v.featured_image && v.featured_image.position != null) {
            variantIndexMap[v.id] = v.featured_image.position - 1;
          }
          valueToVariant[v.option1] = v.id;
          variantPriceMap[v.id] = { price: v.price, compare_at_price: v.compare_at_price };
        });

        // MutationObserver sur le wrapper des thumbnails :
        // dès que le strip scrolle, on le remet à 0 pour que
        // la photo lifestyle reste toujours visible en bas à gauche
        var thumbsWrapper = document.querySelector('.swiper-thumbnails-inline .swiper-wrapper');
        if (thumbsWrapper) {
          var observer = new MutationObserver(function() {
            var t = thumbsWrapper.style.transform;
            if (t && t !== 'translate3d(0px, 0px, 0px)') {
              thumbsWrapper.style.transitionDuration = '0ms';
              thumbsWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
            }
          });
          observer.observe(thumbsWrapper, { attributes: true, attributeFilter: ['style'] });
          // Reset initial position immediately
          thumbsWrapper.style.transitionDuration = '0ms';
          thumbsWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
        }

        function goToIndex(idx) {
          if (idx == null || idx < 0) return;
          var sw = gallery.swiper;
          if (sw) { sw.slideTo(idx, 300); return; }
          try {
            var globalKeys = Object.keys(window).filter(function(k) {
              try { return window[k] && window[k].slideTo && window[k].el === gallery; }
              catch(e) { return false; }
            });
            if (globalKeys.length) { window[globalKeys[0]].slideTo(idx, 300); return; }
          } catch(e) {}
          var thumbs = document.querySelectorAll('.swiper-thumbnail .swiper-slide, #slider-thumbs .swiper-slide, .product-thumb .swiper-slide');
          if (thumbs[idx]) { thumbs[idx].click(); }
        }

        function formatMoney(cents) {
          if (window.Shopify && Shopify.formatMoney && window.DT_THEME && DT_THEME.moneyFormat) {
            return Shopify.formatMoney(cents, DT_THEME.moneyFormat);
          }
          return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
        }

        function updatePrice(variantId) {
          var data = variantPriceMap[variantId];
          if (!data) return;
          // Try multiple price element selectors
          var priceEl = document.querySelector('[id*="ProductPrice"] span') ||
                        document.querySelector('[id*="ProductPrice"]');
          if (priceEl) priceEl.innerHTML = formatMoney(data.price);
          // Compare price
          var compareEl = document.querySelector('[id*="ComparePrice"] span') ||
                          document.querySelector('[id*="ComparePrice"]');
          if (compareEl) {
            if (data.compare_at_price && data.compare_at_price > data.price) {
              compareEl.innerHTML = formatMoney(data.compare_at_price);
              var li = compareEl.closest('li');
              if (li) li.classList.remove('hide');
            } else {
              var li = compareEl.closest('li');
              if (li) li.classList.add('hide');
            }
          }
        }

        function onVariantChange(variantId) {
          var idx = variantIndexMap[variantId];
          if (idx !== undefined) goToIndex(idx);
          updatePrice(variantId);
        }

        function getSelectedVariantId() {
          var sel = document.querySelector('select[name="id"]');
          return sel ? parseInt(sel.value) : null;
        }

        // --- Écouter le select[name="id"] (mis à jour par le thème au clic swatch) ---
        var variantSelect = document.querySelector('select[name="id"]');
        if (variantSelect) {
          variantSelect.addEventListener('change', function() {
            var id = parseInt(this.value);
            if (id) onVariantChange(id);
          });
        }

        // --- Hover sur les swatches texte (swatch.liquid -> .swatch-element[data-value]) ---
        document.addEventListener('mouseover', function(e) {
          var swatch = e.target.closest('.swatch-element[data-value]');
          if (swatch) {
            var value = swatch.getAttribute('data-value');
            var variantId = valueToVariant[value];
            if (variantId) onVariantChange(variantId);
          }
        });

        document.addEventListener('mouseout', function(e) {
          var swatch = e.target.closest('.swatch-element[data-value]');
          if (!swatch) return;
          var rel = e.relatedTarget;
          if (rel && rel.closest && rel.closest('.swatch-element[data-value]')) return;
          var selId = getSelectedVariantId();
          if (selId) onVariantChange(selId);
        });

        // --- Watch URL pour changement de variante (via click swatch) ---
        var lastVariant = null;
        function checkUrl() {
          var params = new URLSearchParams(window.location.search);
          var v = params.get('variant');
          if (v && v !== lastVariant) {
            lastVariant = v;
            onVariantChange(parseInt(v));
          }
          // Also check select in case URL doesn't update
          var selId = getSelectedVariantId();
          if (selId && String(selId) !== lastVariant) {
            lastVariant = String(selId);
            onVariantChange(selId);
          }
        }
        setInterval(checkUrl, 200);

        var orig = history.pushState;
        history.pushState = function() {
          orig.apply(this, arguments);
          setTimeout(checkUrl, 50);
        };

        // Click sur d'autres swatch elements
        document.addEventListener('click', function(e) {
          var el = e.target.closest('[data-value], .swatch-element, label[for]');
          if (el) setTimeout(function() {
            var selId = getSelectedVariantId();
            if (selId) onVariantChange(selId);
          }, 150);
        });

        // Initial
        var params = new URLSearchParams(window.location.search);
        var initV = params.get('variant') || getSelectedVariantId();
        if (initV) { lastVariant = String(initV); onVariantChange(parseInt(initV)); }
      });
  }

  setTimeout(init, 800);
})();